import { HTTPStatusCode } from "@libs/api/types";
import { tsRestClient } from "@/services/ts-rest";
import { logger } from "@/utils/logger";

export const VerifyApiApi = {
  getShortCodeData: async (shortCode: string) => {
    const res = await tsRestClient().verifyApi.getShortCodeData({
      params: { code: shortCode },
    });

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    logger.error({
      error: res.body,
      message: "Failed to get short code data",
      shouldThrowError: true,
    });
  },
};
